import { Col, Layout, Row } from 'antd';
import React from 'react';
import { GroupGeofencePageContextProvider } from './GroupGeofencePage.context';
import './GroupGeofencePage.style.css';
import CreateBoundary from './components/CreateBoundary/CreateBoundary';
import GeofenceList from './components/GeofenceList/GeofenceList';
import GeofenceMap from './components/GeofenceMap/GeofenceMap';
import ModeActionHandler from './components/ModeActionHandler/ModeActionHandler';
import PostGeofence from './components/PostGeofence/PostGeofence';
import SearchGeofence from './components/SearchGeofence/SearchGeofence';
import { useGroupPermissions } from '../../providers/useGroupPermissions';
import { GroupPermission } from '@tenderd/track-web-utils';
var GroupGeofencePage = function () {
    var permissions = useGroupPermissions();
    return (React.createElement(GroupGeofencePageContextProvider, null,
        React.createElement(Layout.Content, { className: "geofence-page-wrapper" },
            React.createElement(Row, { justify: 'space-between', style: { marginBottom: 16 } },
                React.createElement(Col, { flex: "450px" },
                    React.createElement(SearchGeofence, null)),
                permissions === GroupPermission.Admin && (React.createElement(Col, null,
                    React.createElement("div", { className: "header-btns" },
                        React.createElement(ModeActionHandler, null),
                        React.createElement(PostGeofence, null))))),
            React.createElement(Row, { style: { background: 'white', borderRadius: 8 } },
                React.createElement(Col, { style: { padding: 4 }, flex: "450px" },
                    React.createElement("div", { className: "geofence-wrapper-height", id: "scrollableDiv" },
                        React.createElement(GeofenceList, null))),
                React.createElement(Col, { style: { padding: 4, position: 'relative' }, flex: "auto" },
                    React.createElement("div", { className: "geofence-wrapper-height" },
                        React.createElement(CreateBoundary, null),
                        React.createElement(GeofenceMap, null)))))));
};
export default GroupGeofencePage;
